import React, { useEffect, useState } from 'react';
import axios from '../Axiosinstance';
import {
    Container, Typography, Box, Grid, Avatar, Paper, Tabs, Tab, CircularProgress, Table,
    TableBody, TableCell, TableHead, TableRow, Divider, useMediaQuery, TablePagination,
    Button, TextField, IconButton
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import { toast } from 'react-toastify';
import pdfTemplate from '../All/registration-receipt.pdf';
import Instalment from '../pdf/instalment-receipt.pdf'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { saveAs } from 'file-saver';
import calibriFontItalic from '../fonts/calibri-italic.ttf';
import calibriFontBold from '../fonts/CalibriBold.ttf'
import calibriFont from '../fonts/calibri.ttf'
import fontkit from '@pdf-lib/fontkit';
import DownloadIcon from '@mui/icons-material/Download';
import ArialitalicBold2 from '../fonts/ArialMdmItl.ttf'
import ArialItalicBold from '../fonts/ArialCEBoldItalic.ttf'
import ARIALItalicLight from '../fonts/ARIALItalicLight.ttf'
import ARIALNormal from '../fonts/calibri.ttf'
import { removeBracketedText } from '../Axiosinstance';
import dayjs from "dayjs";
import { buttonBackgroundColor } from '../common';

const RegistrationInfo = ({ id }) => {
    const [data, setData] = useState(null);
    const [studentInfo, setStudentInfo] = useState(null);
    const [paymentInfo, setPaymentInfo] = useState(null); // New state for payment data

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabValue, setTabValue] = useState(0);
    const [installmentsPage, setInstallmentsPage] = useState(0);
    const [installmentsRowsPerPage, setInstallmentsRowsPerPage] = useState(5);
    const [courseFeePage, setCourseFeePage] = useState(0);
    const [courseFeeRowsPerPage, setCourseFeeRowsPerPage] = useState(5);
    const [paymentAmount, setPaymentAmount] = useState('');
    const [paymentLink, setPaymentLink] = useState('');
    const [showPaymentInput, setShowPaymentInput] = useState(false);
    const [paymentLoading, setPaymentLoading] = useState(false);
    const [payConfirmed, setPayConfirmed] = useState(true);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [open, setOpen] = useState(false);
    const [pdfFileName, setPdfFileName] = useState('');
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('905'));


    const handleClosePdfDialog = () => {
        setOpen(false);
        setPdfUrl(null);
    };

    const handleDownload = () => {
        if (!pdfUrl || !pdfFileName) return;

        const a = document.createElement('a');
        a.href = pdfUrl;
        a.download = pdfFileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };
    // Fetch registration and payment info
    useEffect(() => {
        axios.get(`/registrationadvances/info/${id}`)
            .then(response => {
                setData(response.data);
                setStudentInfo(response.data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });

        // Fetch payment info
        axios.get(`registrationadvances/paymentDetails-info/${id}`)
            .then(response => {
                setPaymentInfo(response.data); // Store the payment info
            })
            .catch(error => {
                console.error("Error fetching payment info:", error);
            });

    }, [id]);

    const [showPaymentButton, setShowPaymentButton] = useState(false);
    useEffect(() => {
        if (data?.startModuleDate) {
            const moduleDate = dayjs(data.startModuleDate);
            const cutoffDate = dayjs("2025-03-01");
            // Show payment button only if moduleDate is after 2025-03-01
            setShowPaymentButton(moduleDate.isAfter(cutoffDate));
        }
    }, [data]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleInstallmentsPageChange = (event, newPage) => {
        setInstallmentsPage(newPage);
    };

    const handleInstallmentsRowsPerPageChange = (event) => {
        setInstallmentsRowsPerPage(parseInt(event.target.value, 10));
        setInstallmentsPage(0);
    };

    const handleCourseFeePageChange = (event, newPage) => {
        setCourseFeePage(newPage);
    };

    const handleCourseFeeRowsPerPageChange = (event) => {
        setCourseFeeRowsPerPage(parseInt(event.target.value, 10));
        setCourseFeePage(0);
    };

    const handlePaymentChoice = () => {
        if (!paymentInfo || paymentInfo?.totalWanttoPaid === 0) {
          toast.error("You are not eligible to make a payment. Total amount due is 0.");
          return;
        }
      
        const successUrl = window.location.origin + "/Invoice/" + "jurong_academy_" + id + "_invoice";
        const cancelUrl = window.location.href;
        const paymentMethod = 'online';
      
        if (paymentAmount < 1 || paymentAmount > paymentInfo?.totalWanttoPaid) {
          toast.error(`The amount must be ${paymentInfo?.totalWanttoPaid} SGD for online payments.`);
          return;
        }
      
        setPaymentLoading(true);
      
        // Update the payment amount first
        axios.post(`registrationadvances/${id}/PaymentAmount`, { paymentAmount: paymentAmount })
          .then(() => {
            // Proceed with Stripe payment creation
            axios.post('/api/v1/stripe/create-payment', {
              amount: paymentAmount * 100, // Convert to cents
              quantity: 1,
              currency: 'sgd',
              name: data.name,
              successUrl: successUrl,
              cancelUrl: cancelUrl,
              client_reference_id: data.studentId
            })
            .then(response => {
              const { data } = response;
              setPaymentLink(data.data.sessionUrl);
              // Removed the course-fee-details post here
              setPaymentLoading(false);
              toast.success("Payment link generated successfully.");
              setPayConfirmed(false);
            })
            .catch(error => {
              setPaymentLoading(false);
              console.error('Error creating payment session:', error);
              toast.error("Error creating payment session. Please try again.");
            });
          })
          .catch(error => {
            setPaymentLoading(false);
            console.error('Error updating payment amount:', error);
            toast.error("Error updating payment amount. Please try again.");
          });
      };
      


    if (loading) {
        return (
            <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Container>
        );
    }



    if (error) {
        return (
            <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Typography variant="h6" color="error">
                    Error: {error.message}
                </Typography>
            </Container>
        );
    }



    const numberToWords = (number) => {
        const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
        const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
        const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

        const numToWords = (num) => {
            let words = [];

            if (num >= 1000) {
                words.push(ones[Math.floor(num / 1000)] + ' thousand');
                num %= 1000;
            }
            if (num >= 100) {
                words.push(ones[Math.floor(num / 100)] + ' hundred');
                num %= 100;
            }
            if (num >= 10 && num <= 19) {
                words.push(teens[num - 10]);
                return words.join(' '); // Directly return since teens (11-19) are standalone
            }
            if (num >= 20) {
                words.push(tens[Math.floor(num / 10)]);
                num %= 10;
            }
            if (num > 0) {
                words.push(ones[num]);
            }

            return words.join(' ').trim();
        };

        return number === 0 ? 'zero' : numToWords(number);
    };

    for (let i = 1; i <= 200; i++) {
        console.log(`${i}: ${numberToWords(i)}`);
    }



    const toUpperCaseString = (str) => {
        return str?.toUpperCase();
    };
    const toUpperCaseString1 = (str) => {
        // Remove trailing numbers within parentheses
        return str.replace(/\(\d+\)$/, '').toUpperCase();
    };

    const getMonthName = (monthNumber) => {
        const monthNames = [
            "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
            "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
        ];
        return monthNames[monthNumber];
    };

    // Function to format the date
    const toUpperCaseString11 = (dateString) => {
        const date = new Date(dateString);
        const month = getMonthName(date.getMonth());
        const year = date.getFullYear();
        return `${month} ${year}`;
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };


    // Function to get the last two digits of the year from a date string
    const getYear = (dateString) => {
        const date = new Date(dateString);
        return date.getFullYear().toString().slice(-2); // Get last two digits of the year
    };

    const registrationFee = studentInfo?.installmentsPaid?.length > 0 ? studentInfo.installmentsPaid[studentInfo.installmentsPaid.length - 1].amount : 0;
    const gst = registrationFee - (registrationFee / 1.09);
    const sumOfDollars = numberToWords(registrationFee);

    const getOrdinalSuffix = (num) => {
        const j = num % 10,
            k = num % 100;
        if (j == 1 && k != 11) {
            return num + "st";
        }
        if (j == 2 && k != 12) {
            return num + "nd";
        }
        if (j == 3 && k != 13) {
            return num + "rd";
        }
        return num + "th";
    };

    // const formValues = {
    //   invoiceNo: `INVJA${studentInfo.id}`, // Example: INVJA2
    //   date: new Date(studentInfo.date).toLocaleDateString(),
    //   studentName: toUpperCaseString(`${studentInfo.name} ${studentInfo.sureName}`),
    //   passportNo: studentInfo.nric, // Assuming you have this field in studentInfo
    //   course: toUpperCaseString1(studentInfo.course), // Assuming you have this field in studentInfo
    //   intake: toUpperCaseString(studentInfo.intakeId), // Assuming you have this field in studentInfo
    //   registrationFees: registrationFee.toFixed(2), // Assuming registrationFee is a number
    //   gst: `${gst.toFixed(2)} )`, // Example static value for GST
    //   balance: `${studentInfo?.registrationFeeRemaining}`, // Assuming registrationFeeRemaining is a number
    //   sumOfDollars: toUpperCaseString(`${sumOfDollars} DOLLOR ONLY`),  // Assuming totalPaidAmount is a number
    //   total: registrationFee.toFixed(2),
    // //  name: 'John Smith',
    //   registrationFee1: registrationFee.toFixed(2),
    //   approver: studentInfo.approver,
    // };


    // if (error) {
    //   return <div>Error: {error.message}</div>; // Error state
    // }


    const handlePdfEdit = async (installment, index) => {

        const pdfBytes = await fetch(pdfTemplate).then((res) => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(pdfBytes);
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];
        pdfDoc.registerFontkit(fontkit);


        // Example: Assuming formValues contains user input
        // const { invoiceNo, totalFee, installmentCount, feeType } = formValues;

        // Load the font
        const calibriFontBytes = await fetch(calibriFont).then((res) => res.arrayBuffer());
        const calibriFontEmbed = await pdfDoc.embedFont(calibriFontBytes);

        const calibriFontBoldBytes = await fetch(calibriFontBold).then((res) => res.arrayBuffer());
        const calibriFontBoldEmbed = await pdfDoc.embedFont(calibriFontBoldBytes);

        const calibriFontItalicBytes = await fetch(calibriFontItalic).then((res) => res.arrayBuffer());
        const calibriFontItalicEmbed = await pdfDoc.embedFont(calibriFontItalicBytes);

        // Example: Draw text using the embedded font and user input values
        // firstPage.drawText(`Installment Count: ${installment.installmentCount}`, { x: 50, y: 600, size: 12, font: calibriFontEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(`TAX INVOICE`, { x: 420, y: 775, size: 19, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(`GST No. 201322342Z`, { x: 420, y: 760, size: 12, font: calibriFontEmbed, color: rgb(0, 0, 0) });


        firstPage.drawText(
            `  ${studentInfo.late
                ? (index === 0
                    ? formatDate(studentInfo.scheduleDate)
                    : formatDate(installment.sessionDate)
                )
                : formatDate(installment.sessionDate)
            }`,
            { x: 380, y: 666.5, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) }
        );

        firstPage.drawText(` $${installment.amount}`, { x: 478, y: 565, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` $${installment.amount}`, { x: 478, y: 493, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });

        firstPage.drawText(` $${((installment.amount) - (installment.amount / 1.09)).toFixed(2)})`, { x: 152, y: 545, size: 9, font: calibriFontItalicEmbed, color: rgb(0, 0, 0) });
        // firstPage.drawText(` ${installment.amount} (OMT)`, { x: 142, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` ${installment.amount}`, { x: 142, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
        if (installment.paymentMode === 'online') {
            firstPage.drawText(` ${installment.amount} (OMT)`, { x: 142, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
        }

        firstPage.drawText(` ${toUpperCaseString1(numberToWords(installment.amount))} DOLLARS ONLY`, { x: 131.5, y: 495, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` ${installment.registrationFeeRemaining}`, { x: 109, y: 522, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });


        firstPage.drawText(`OFFICIAL INVOICE NO:`, { x: 360, y: 677, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });

        if (studentInfo) {
            const invoiceString = `JA${getYear(installment.sessionDate)}-${String(installment.sequenceNumber).padStart(4, '0')}-${studentInfo.nric}-R`;
            // const x = 410;
            const x = 445;
            const y = 677;
            const size = 9;
            const font = calibriFontBoldEmbed;
            firstPage.drawText(invoiceString, { x, y, size, font, color: rgb(0, 0, 0) });

            // Measure the width of the text
            const textWidth = font.widthOfTextAtSize(invoiceString, size);
            // Draw the underline
            firstPage.drawLine({
                start: { x, y: y - 1 },
                end: { x: x + textWidth, y: y - 1 },
                thickness: 0.5,
                color: rgb(0, 0, 0),
            });
            firstPage.drawText(` ${toUpperCaseString1(studentInfo.name)}`, { x: 184, y: 641.6, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
            firstPage.drawText(` ${toUpperCaseString1(studentInfo.nric)}`, { x: 184, y: 629.3, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
            firstPage.drawText(` ${toUpperCaseString1(studentInfo.course)}`, { x: 184, y: 617, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
            firstPage.drawText(` ${toUpperCaseString11(studentInfo.startModuleDate)}`, { x: 184, y: 605, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
            firstPage.drawText('This is computer generated document no signature required.', { x: 69, y: 450, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });

            // firstPage.drawText(` ${toUpperCaseString1(studentInfo.approver)}`, { x: 100.5, y: 479, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });

            // if (installment.discountAmount !== 0 && installment.discountAmount !== null) {
            //   firstPage.drawText(` Discount:$${installment.discountAmount}`, { x: 70, y: 533, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
            // }


            if (studentInfo.amount1 != 0 && index === 0) {
                // If studentinfo.amount1 is not equal to 0, display the discount
                firstPage.drawText(` Discount:$${studentInfo.amount1}`, {
                    x: 70,
                    y: 533,
                    size: 9,
                    font: calibriFontEmbed,
                    color: rgb(0, 0, 0)
                });
            } else if (installment.discountAmount !== 0 && installment.discountAmount !== null) {
                // If installment.discountAmount is not 0 and not null, display the discount
                firstPage.drawText(` Discount:$${installment.discountAmount}`, {
                    x: 70,
                    y: 533,
                    size: 9,
                    font: calibriFontEmbed,
                    color: rgb(0, 0, 0)
                });
            }

            // Add more student details as needed
        }


        // Save the PDF document
        // const pdfBytesEdited = await pdfDoc.save();
        // const blob = new Blob([pdfBytesEdited], { type: 'application/pdf' });
        // saveAs(blob, `${toUpperCaseString(studentInfo.name)}-REGISTRATION-RECEIPT.pdf`);

        const pdfBytesModified = await pdfDoc.save();
        const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        // window.open(pdfUrl, '_blank');
        // saveAs(pdfBlob, `${toUpperCaseString(studentInfo.name)}-REG-${installment.sequenceNumber}.pdf`);
        const studentName = studentInfo.name.replace(/\s+/g, '_');
        const fileName = `${studentName}_REG_${installment.sequenceNumber}.pdf`;
        setPdfUrl(pdfUrl);
        setPdfFileName(fileName);
        setOpen(true); // Open dialog
    };

    const handlePdfEdit1 = async (feeDetail, type) => {

        const pdfBytes = await fetch(Instalment).then((res) => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(pdfBytes);
        const pages = pdfDoc.getPages();
        const firstPage = pages[0];
        pdfDoc.registerFontkit(fontkit);


        // Example: Assuming formValues contains user input
        // const { invoiceNo, totalFee, installmentCount, feeType } = formValues;

        // Load the font
        const calibriFontBytes = await fetch(calibriFont).then((res) => res.arrayBuffer());
        const calibriFontEmbed = await pdfDoc.embedFont(calibriFontBytes);


        const calibriFontBoldBytes = await fetch(calibriFontBold).then((res) => res.arrayBuffer());
        const calibriFontBoldEmbed = await pdfDoc.embedFont(calibriFontBoldBytes);

        const calibriFontItalicBytes = await fetch(ArialitalicBold2).then((res) => res.arrayBuffer());
        const calibriFontItalicEmbed = await pdfDoc.embedFont(calibriFontItalicBytes);

        const calibriFontItalicBoldBytes = await fetch(ArialItalicBold).then((res) => res.arrayBuffer());
        const calibriFontItalicBoldEmbed = await pdfDoc.embedFont(calibriFontItalicBoldBytes);

        const ArialItalicLight = await fetch(ARIALItalicLight).then((res) => res.arrayBuffer());
        const ArialItalicLightEmbed = await pdfDoc.embedFont(ArialItalicLight);

        // Example: Draw text using the embedded font and user input values
        firstPage.drawText(`  ${formatDate(feeDetail.sessionDate)}`, { x: 384, y: 629.5, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` $${feeDetail.amount}`, { x: 475.5, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` ${feeDetail.amount}`, { x: 483.5, y: 474, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });

        firstPage.drawText(` $${((feeDetail.amount) - (feeDetail.amount / 1.09)).toFixed(2)})`, { x: 184, y: 530, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
        const installmentText = feeDetail.installmentCounts
            .map((count) => `${getOrdinalSuffix(count)}`)
            .join(","); // Join them with a space
        console.log("feeDetail.installmentCounts", installmentText);
        // firstPage.drawText(` ${feeDetail.installmentCount} ${' '} Instalment $${feeDetail.amount} (OMT)`, { x: 75, y: 540.8, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` ${installmentText} ${' '} Installment $${feeDetail.amount} `, { x: 75, y: 540.8, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
        if (feeDetail.paymentMode === 'online') {
            firstPage.drawText(` (OMT)`, { x: 168, y: 541, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
        }


        // firstPage.drawText(` ${installment.amount}`, { x: 142, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
        // firstPage.drawText(` ${getOrdinalSuffix(feeDetail.installmentCounts[0])}`, { x: 81, y: 545, size: 6, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` ${toUpperCaseString1(numberToWords(feeDetail.amount))} DOLLARS ONLY`, { x: 141.5, y: 475.3, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
        const currentInstallments = feeDetail.installmentCounts || [];
        let installmentDisplayText = "";

        // if (feeDetail.remainingBalance === 0) {
        //   // If there is no remaining balance, show the next installment count only
        //   const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
        //   installmentDisplayText = `${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
        // } else {
        //   // If there is a remaining balance, include both current balance and next installment
        //   const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
        //   installmentDisplayText = `${lastInstallment}${getOrdinalSuffix(lastInstallment)} Balance, ${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
        // }
        if (type === "diploma") {
            if (feeDetail.remainingBalance === 0) {
                // If there is no remaining balance, show the next installment count only
                const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
                if (lastInstallment >= 12) {
                    installmentDisplayText = "-";
                }
                else {
                    installmentDisplayText = `${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
                }
            } else {
                // If there is a remaining balance, include both current balance and next installment
                const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
                if (lastInstallment >= 12) {
                    installmentDisplayText = "-";
                }
                else {
                    installmentDisplayText = `${getOrdinalSuffix(lastInstallment)} Balance, ${getOrdinalSuffix(lastInstallment + 1)} Installment`;
                }
            }
        }
        else if (type === "advance_diploma") {
            if (feeDetail.remainingBalance === 0) {
                // If there is no remaining balance, show the next installment count only
                const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
                if (lastInstallment >= 6) {
                    installmentDisplayText = "-";
                }
                else {
                    installmentDisplayText = `${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
                }
            } else {
                // If there is a remaining balance, include both current balance and next installment
                const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
                if (lastInstallment > 6) {
                    installmentDisplayText = "-";
                }
                else if (lastInstallment === 6) {
                    installmentDisplayText = `${lastInstallment}${getOrdinalSuffix(lastInstallment)} Balance`;
                }
                else {
                    installmentDisplayText = `${lastInstallment}${getOrdinalSuffix(lastInstallment)} Balance, ${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
                }
            }

        }

        firstPage.drawText(` ${installmentDisplayText}${'  '} `, { x: 190, y: 496.5, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
        // firstPage.drawText(` ${getOrdinalSuffix(feeDetail.installmentCount + 1)} `, { x: 196, y: 500.5, size: 6, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` $${feeDetail.courseFeeRemaining}`, { x: 156, y: 507.5, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });

        if (studentInfo) {


            const paid_date = getYear(feeDetail.sessionDate);
            const formatteddate = paid_date % 100;
            const sequenceNumber = String(feeDetail.sequenceNumber).padStart(4, '0');
            const invoiceString = `JAO/CF-${formatteddate}-${sequenceNumber}`;
            const x = 455;
            const y = 644.3;
            const size = 9;
            const font = calibriFontBoldEmbed;
            firstPage.drawText(toUpperCaseString1(invoiceString), { x, y, size, font, color: rgb(0, 0, 0) });

            // Measure the width of the text
            const textWidth = font.widthOfTextAtSize(invoiceString, size);
            // Draw the underline
            firstPage.drawLine({
                start: { x, y: y - 1 },
                end: { x: x + textWidth, y: y - 1 },
                thickness: 0.5,
                color: rgb(0, 0, 0),
            });

            // firstPage.drawText(invoiceString, { x: 450.5, y: 350, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
            firstPage.drawText(` ${toUpperCaseString1(studentInfo.name)}`, { x: 184, y: 618, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
            firstPage.drawText(` ${toUpperCaseString1(studentInfo.nric)}`, { x: 184, y: 607.5, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
            firstPage.drawText(` ${toUpperCaseString1(studentInfo.course)}`, { x: 184, y: 597.2, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
            firstPage.drawText(` ${toUpperCaseString11(studentInfo.startModuleDate)}`, { x: 184, y: 586, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
            firstPage.drawText('This is computer generated document no signature required.', { x: 75, y: 420, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
            if (feeDetail.discountAmount !== 0) {
                firstPage.drawText(`Discount: ${feeDetail.discountAmount}`, {
                    x: 78,
                    y: 487,
                    size: 9,
                    // font: calibriFontBoldEmbed,
                    color: rgb(0, 0, 0),
                });
            }

            // firstPage.drawText(` ${toUpperCaseString1(studentInfo.approver)}`, { x: 104, y: 439, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
            // Add more student details as needed
        }

        // Save the PDF document
        // const pdfBytesEdited = await pdfDoc.save();
        // const blob = new Blob([pdfBytesEdited], { type: 'application/pdf' });
        // saveAs(blob, `${toUpperCaseString(studentInfo.name)}-COURSE-RECEIPT.pdf`);
        const pdfBytesModified = await pdfDoc.save();
        const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        // window.open(pdfUrl, '_blank');
        // saveAs(pdfBlob, `${toUpperCaseString(studentInfo.name)}-INS-${feeDetail.sequenceNumber}.pdf`);
        const studentName = studentInfo.name.replace(/\s+/g, '_');
        const fileName = `${studentName}_INS_${feeDetail.installmentCounts}.pdf`;
        setPdfUrl(pdfUrl);
        setPdfFileName(fileName);
        setOpen(true); // Open dialog
    };



    const handlePaymentClick = () => {
        // Open the payment link in a new tab
        // window.open(paymentLink, '_blank', 'noopener,noreferrer');
        // Reload the current page
        // window.location.reload();
        window.location.href = paymentLink;
    };


    const courseFeeDetails = data?.courseFeeDetails || [];
    const registrationFeeDetails = data?.installmentsPaid || [];
    let registrationFeeRemaining = 0;
    let currentRemainingBalance = 0;
    const paidDetails = courseFeeDetails.filter(detail => detail.status === "Paid");
    const registrationpaidDetails = registrationFeeDetails.filter(detail => detail.status === "Paid");

    if (paidDetails.length > 0 || registrationpaidDetails.length > 0) {
        const lastEntry = paidDetails[paidDetails.length - 1];
        const registrationlastEntry = registrationpaidDetails[registrationpaidDetails.length - 1];

        registrationFeeRemaining = registrationlastEntry.registrationFeeRemaining || 0;
        currentRemainingBalance = lastEntry?.courseFeeRemaining || data?.courseFee;
      }

    return (
        <Container maxWidth="lg">
            <Box sx={{ my: 4 }}>
                <Paper elevation={3} sx={{ p: 2 }}>
                    <Typography variant="h4" component="h1" gutterBottom align="center">
                        Registration Information
                    </Typography>
                    <Box p={isSmallScreen ? 1 : 2}>
                        <Typography variant="h6" component="h3" gutterBottom>
                            Personal Information
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Box display="flex" alignItems="center">
                                    <Avatar sx={{ bgcolor: 'primary.main', width: 30, height: 30, mr: 1 }}>
                                        <PersonIcon fontSize={isSmallScreen ? 'small' : 'medium'} />
                                    </Avatar>
                                    <Box>
                                        <Typography variant="body2">
                                            <strong>Name:</strong> {data.name}
                                        </Typography>
                                        {/* <Typography variant="caption">Student ID: {data.studentId}</Typography> */}
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box display="flex" alignItems="center">
                                    <Avatar sx={{ bgcolor: 'secondary.main', width: 30, height: 30, mr: 1 }}>
                                        <HomeIcon fontSize={isSmallScreen ? 'small' : 'medium'} />
                                    </Avatar>
                                    <Box>
                                        <Typography variant="body2">
                                            <strong>Address:</strong> {data.addressHome}
                                        </Typography>
                                        <Typography variant="caption">Email: {data.email}</Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box display="flex" alignItems="center">
                                    <Avatar sx={{ bgcolor: 'secondary.main', width: 30, height: 30, mr: 1 }}>
                                        <AccountBalanceIcon fontSize={isSmallScreen ? 'small' : 'medium'} />
                                    </Avatar>
                                    <Box>
                                        <Typography variant="body2">
                                            {/* <strong>Passport No:</strong> {data.passportNo} */}
                                            <strong>NRIC:</strong> {data.nric}
                                            {/* <Typography variant="caption">NRIC: {data.nric}</Typography> */}
                                        </Typography>

                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box display="flex" alignItems="center">
                                    <Avatar sx={{ bgcolor: 'secondary.main', width: 30, height: 30, mr: 1 }}>
                                        <AccountBalanceIcon fontSize={isSmallScreen ? 'small' : 'medium'} />
                                    </Avatar>
                                    <Box>
                                        <Typography variant="body2">
                                            <strong>Course:</strong> {removeBracketedText(data.course)}
                                        </Typography>
                                        {/* <Typography variant="caption">Intake ID: {data.intakeId}</Typography> */}
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    <Divider sx={{ my: 2 }} />
                    <Box p={isSmallScreen ? 1 : 2}>
                        <Typography variant="h6" component="h3" gutterBottom>
                            Fees and Payments
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2">Registration Fee: ${data.registrationFee}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2">Registration Fee Remaining: ${registrationFeeRemaining}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                {/* <Typography variant="body2">Total  Paid: ${data.totalPaidAmount}</Typography> */}
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2">Course Fee: ${data.courseFee}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2">Course Fee Remaining: ${currentRemainingBalance}</Typography>
                            </Grid>

                            {/* <Grid item xs={12} sm={4}>
                                <Typography variant="body2">
                                    Payment Status: {data.paymentStatus === "pending" ?
                                        <ErrorIcon color="error" fontSize={isSmallScreen ? 'small' : 'medium'} /> :
                                        <CheckCircleIcon color="success" fontSize={isSmallScreen ? 'small' : 'medium'} />}
                                </Typography>
                            </Grid> */}
                        </Grid>
                        <Box mt={2} display="flex" flexDirection="column" alignItems="center">
                            {!paymentLink && showPaymentButton && (
                                showPaymentInput ? (
                                    <>
                                        <Box display="flex" justifyContent="space-between" width="100%" maxWidth="700px">
                                            <Typography variant="h6" gutterBottom>
                                                Enter the amount you wish to pay ({paymentInfo ? paymentInfo?.totalWanttoPaid : '0'} SGD):
                                            </Typography>
                                            <IconButton onClick={() => { setShowPaymentInput(false) }}>
                                                <CloseIcon />
                                            </IconButton>
                                        </Box>
                                        <TextField
                                            label="Amount (SGD)"
                                            value={paymentAmount}
                                            onChange={(e) => setPaymentAmount(e.target.value)}
                                            type="number"
                                            InputProps={{ inputProps: { min: 50, max: paymentInfo ? paymentInfo?.totalWanttoPaid : 0 } }}
                                            variant="outlined"
                                            sx={{ mb: 2, width: '100%', maxWidth: 600 }}
                                            disabled={paymentInfo && paymentInfo?.totalWanttoPaid === 0}
                                        />
                                        {paymentLoading ? (
                                            <CircularProgress />
                                        ) : (
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={handlePaymentChoice}
                                                disabled={!payConfirmed || paymentInfo?.totalWanttoPaid === 0}
                                            >
                                                Proceed to Pay
                                            </Button>
                                        )}
                                    </>
                                ) : (
                                    <Button variant="contained" color="primary" onClick={() => setShowPaymentInput(true)}>
                                        Make a Payment
                                    </Button>
                                )
                            )}

                            {paymentLink && (
                                <Box mt={2} display="flex" flexDirection="column" alignItems="center">
                                    <Typography variant="body1">
                                        <Button variant="contained" color="primary" onClick={() => window.location.href = paymentLink}>
                                            Click here to complete your payment
                                        </Button>
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        You will be redirected to the secure Stripe payment page.
                                    </Typography>
                                </Box>
                            )}
                        </Box>

                    </Box>
                    <Divider sx={{ my: 2 }} />
                    <Tabs value={tabValue} onChange={handleTabChange} centered  >
                        <Tab label="Registration Fee Details" />
                        <Tab label="Course Fee Details" />
                    </Tabs>
                    {tabValue === 0 && (
                        <Box>
                            <Typography variant="h6" component="h3" gutterBottom>
                                Installments Paid
                            </Typography>
                            {isSmallScreen ? (
                                data.installmentsPaid
                                    .filter(inst => inst.status === "Paid")
                                    .slice(installmentsPage * installmentsRowsPerPage, installmentsPage * installmentsRowsPerPage + installmentsRowsPerPage)
                                    .map((installment, index) => (
                                        <Box key={index} mb={2} p={2} border={1} borderColor="grey.300" borderRadius={2}>
                                            {/* <Typography variant="body1"><strong>Installment Count:</strong> {installment.installmentCount}</Typography> */}
                                            <Typography variant="body1"><strong>Amount:</strong> ${installment.amount}</Typography>
                                            <Typography variant="body1"><strong>Payment Mode:</strong> {installment.paymentMode}</Typography>
                                            <Typography variant="body1"><strong>Session Date:</strong> {installment.sessionDate}</Typography>
                                            {/* <Typography variant="body1"><strong>Fee Type:</strong> {installment.feeType}</Typography> */}
                                            <Typography variant="body1"><strong>Remarks:</strong> {installment.remarks}</Typography>
                                            <Typography>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    startIcon={<DownloadIcon />}
                                                    onClick={() => handlePdfEdit(installment, index)} // Pass installment data here

                                                >
                                                    Download Receipt
                                                </Button>
                                            </Typography>
                                        </Box>
                                    ))
                            ) : (
                                <>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                {/* <TableCell>Installment Count</TableCell> */}
                                                <TableCell>Amount</TableCell>
                                                <TableCell>Payment Mode</TableCell>
                                                <TableCell>Session Date</TableCell>
                                                {/* <TableCell>Fee Type</TableCell> */}
                                                <TableCell>Remarks</TableCell>
                                                <TableCell>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.installmentsPaid
                                                .filter(inst => inst.status === "Paid")
                                                .slice(installmentsPage * installmentsRowsPerPage, installmentsPage * installmentsRowsPerPage + installmentsRowsPerPage)
                                                .map((installment, index) => (
                                                    <TableRow key={index}>
                                                        {/* <TableCell>{installment.installmentCount}</TableCell> */}
                                                        <TableCell>${installment.amount}</TableCell>
                                                        <TableCell>{installment.paymentMode}</TableCell>
                                                        <TableCell>{installment.sessionDate}</TableCell>
                                                        {/* <TableCell>{installment.feeType}</TableCell> */}
                                                        <TableCell>{installment.remarks}</TableCell>
                                                        <TableCell>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                startIcon={<DownloadIcon />}
                                                                onClick={() => handlePdfEdit(installment, index)} // Pass installment data here

                                                            >
                                                                Download Receipt
                                                            </Button>
                                                        </TableCell>

                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 15]}
                                        component="div"
                                        count={data.installmentsPaid.length}
                                        rowsPerPage={installmentsRowsPerPage}
                                        page={installmentsPage}
                                        onPageChange={handleInstallmentsPageChange}
                                        onRowsPerPageChange={handleInstallmentsRowsPerPageChange}
                                    />
                                </>
                            )}
                        </Box>
                    )}
                    {tabValue === 1 && (
                        <Box>
                            <Typography variant="h6" component="h3" gutterBottom>
                                Course Fee Details
                            </Typography>
                            {isSmallScreen ? (
                                data.courseFeeDetails
                                    .filter(fee => fee.status === "Paid")
                                    .slice(courseFeePage * courseFeeRowsPerPage, courseFeePage * courseFeeRowsPerPage + courseFeeRowsPerPage)
                                    .map((feeDetail, index) => (
                                        <Box key={index} mb={2} p={2} border={1} borderColor="grey.300" borderRadius={2}>
                                            {/* <Typography variant="body1"><strong>Installment Count:</strong> {feeDetail.installmentCount}</Typography> */}
                                            <Typography variant="body1"><strong>Amount:</strong> ${feeDetail.amount}</Typography>
                                            <Typography variant="body1"><strong>Payment Mode:</strong> {feeDetail.paymentMode}</Typography>
                                            <Typography variant="body1"><strong>Session Date:</strong> {feeDetail.sessionDate}</Typography>
                                            {/* <Typography variant="body1"><strong>Fee Type:</strong> {feeDetail.feeType}</Typography> */}
                                            <Typography variant="body1"><strong>Remarks:</strong> {feeDetail.remarks}</Typography>
                                            <Typography>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    startIcon={<DownloadIcon />}
                                                    onClick={() => handlePdfEdit1(feeDetail, data?.type, feeDetail.sequenceNumber)} // Pass installment data here


                                                >
                                                    Download Receipt
                                                </Button>
                                            </Typography>
                                        </Box>
                                    ))
                            ) : (
                                <>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                {/* <TableCell>Installment Count</TableCell> */}
                                                <TableCell>Amount</TableCell>
                                                <TableCell>Payment Mode</TableCell>
                                                <TableCell>Session Date</TableCell>
                                                {/* <TableCell>Fee Type</TableCell> */}
                                                <TableCell>Remarks</TableCell>
                                                <TableCell>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.courseFeeDetails
                                                .filter(fee => fee.status === "Paid")
                                                .slice(courseFeePage * courseFeeRowsPerPage, courseFeePage * courseFeeRowsPerPage + courseFeeRowsPerPage)
                                                .map((feeDetail, index) => (
                                                    <TableRow key={index}>
                                                        {/* <TableCell>{feeDetail.installmentCount}</TableCell> */}
                                                        <TableCell>${feeDetail.amount}</TableCell>
                                                        <TableCell>{feeDetail.paymentMode}</TableCell>
                                                        <TableCell>{feeDetail.sessionDate}</TableCell>
                                                        {/* <TableCell>{feeDetail.feeType}</TableCell> */}
                                                        <TableCell>{feeDetail.remarks}</TableCell>
                                                        <TableCell>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                startIcon={<DownloadIcon />}
                                                                onClick={() => handlePdfEdit1(feeDetail, data?.type, feeDetail.sequenceNumber)}// Pass installment data here

                                                            >
                                                                Download Receipt
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 15]}
                                        component="div"
                                        count={data.courseFeeDetails.length}
                                        rowsPerPage={courseFeeRowsPerPage}
                                        page={courseFeePage}
                                        onPageChange={handleCourseFeePageChange}
                                        onRowsPerPageChange={handleCourseFeeRowsPerPageChange}
                                    />
                                </>
                            )}
                        </Box>
                    )}
                </Paper>
            </Box>
            <Dialog open={open} onClose={() => setOpen(false)} fullScreen>
                <DialogTitle>View Receipt</DialogTitle>
                <DialogContent>
                    {pdfUrl && (
                        <iframe src={pdfUrl} width="100%" height="100%" style={{ minHeight: '90vh' }} title="PDF Preview"></iframe>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClosePdfDialog()} color='error' variant='contained'>Close</Button>
                    {pdfUrl && (
                        <Button sx={{ backgroundColor: buttonBackgroundColor }} variant="contained" onClick={() => handleDownload()}>
                            Download
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default RegistrationInfo;


